<template>
  <div class="patient-form-container" :class="modalTheme">
    <!-- Add the load button at the top -->
    <div v-if="A" class="form-actions-top">
      <!-- <button :disabled="!patientStore.currentPatient.lastName" type="button" class="btn btn-info" @click="loadFromPatientStore">Load Current Patient from Store</button> -->
      <b-button type="button" class="btn btn-secondary" size="sm" @click="loadFromProps">Load from Props</b-button>
      <b-button type="button" class="btn btn-secondary" size="sm" @click="loadSampleData">Load Sample Data</b-button>
      <b-button type="button" class="btn btn-danger" size="sm" @click="loadSampleDataOoRange">Load Out RANGE Data</b-button>
      <span v-if="patientStore.currentPatient.lastName" class="current-patient-info"> Current: {{ patientStore.currentPatient.firstName }} {{ patientStore.currentPatient.lastName }} </span>
      <span v-else class="no-patient-info"> No current patient selected </span>
    </div>
    <!-- record {{ props.record }}
    <br />

    isNewRecord {{ props.isNewRecord }} -->

    <!-- record {{ formattedCollectionDateTime }} -->
    <!-- <h2>Patient Vitals FORM</h2> -->
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" :class="modalTheme" style="paddiing-left: 12px; padding-right: 12px">
      <b-row class="gutter-6">
        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass">
            <b-row>
              <b-col>
                <h3 style="text-align: left">Patient Vitals:</h3>
              </b-col>
              <b-col>
                <h5 style="text-align: center">{{ formattedCollectionDateTime }}</h5>
              </b-col>

              <!-- <button :class="modalTheme" type="button" class="btn" size="sm" @click="toggleUnits" style="padding: 0%; height: 20px; display: flex; align-items: center; justify-content: center">
                <span style="font-size: 10pt">{{ isMetric ? "🌡️ Switch to Imperial (°F, in, lbs)" : "🌡️ Switch to Metric (°C, cm, kg)" }}</span>
              </button> -->
            </b-row>

            <!-- weight height -->
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group label="weight:" label-for="weight" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-input-group size="sm" :state="weightValidation">
                    <b-form-input
                      id="weight"
                      v-model="form.weight"
                      type="number"
                      :min="form.isMetric ? '32' : '70'"
                      :max="form.isMetric ? '136' : '300'"
                      step="0.1"
                      :class="modalTheme"
                      :state="weightValidation"
                      :placeholder="form.isMetric ? '32.0 - 136.0' : '70.0 - 300.0'"
                      @focus="emit('field-focused', 'weight')"
                    />
                    <b-input-group-append>
                      <b-input-group-text :class="modalTheme">{{ form.isMetric ? "kg" : "lbs" }}</b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback :state="weightValidation"> Weight must be between {{ form.isMetric ? "32 and 136 kg" : "70.0 and 300.0 lbs" }} </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="height:" label-for="height" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-input-group size="sm" :state="heightValidation">
                    <b-form-input
                      id="height"
                      v-model="form.height"
                      type="number"
                      :min="form.isMetric ? '137' : '54'"
                      :max="form.isMetric ? '183' : '80'"
                      step="0.125"
                      :class="modalTheme"
                      :state="heightValidation"
                      :placeholder="form.isMetric ? '137 - 183' : '54 - 80'"
                      @focus="emit('field-focused', 'height')"
                    />
                    <b-input-group-append>
                      <b-input-group-text :class="modalTheme">{{ form.isMetric ? "cm" : "in" }}</b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback :state="heightValidation"> Height must be between {{ form.isMetric ? "137 and 183 cm" : "54 and 72 inches" }} </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- BP -->
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group label="BP:" label-for="bp" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-row class="g-2" no-gutters>
                    <b-col cols="6">
                      <b-input-group size="sm">
                        <b-form-input type="number" id="bpSystolic" v-model="form.bpSystolic" :class="modalTheme" placeholder="120" />
                        <b-input-group-append>
                          <b-input-group-text style="font-size: smaller" :class="modalTheme">mmHg</b-input-group-text>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>

                    <!-- <b-col> <span>/</span> </b-col> -->
                    <b-col cols="6">
                      <b-input-group size="sm">
                        <b-form-input type="number" id="bpDiastolic" v-model="form.bpDistolic" :class="modalTheme" placeholder="80" />
                        <b-input-group-append>
                          <b-input-group-text :class="modalTheme" style="font-size: smaller">mmHg</b-input-group-text>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="BP position:" label-for="bpPosition" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-form-select id="bpPosition" v-model="form.bpPosition" size="sm" :class="modalTheme" :options="bpPositionOptions" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group label="Cuff location:" label-for="bpCuffLocation" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-form-select id="bpCuffLocation" v-model="form.bpCuffLocation" size="sm" :class="modalTheme" :options="bpCuffLocationOptions" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group label="Cuff size:" label-for="bpCuffSize" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-form-select id="bpCuffSize" v-model="form.bpCuffSize" size="sm" :class="modalTheme" :options="bpCuffSizeOptions" />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass" v-unit-background="isMetric">
            <!-- temp -->
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group label="temperature:" label-for="temperature" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-input-group size="sm" :state="temperatureValidation">
                    <b-form-input
                      id="temperature"
                      v-model="form.temperature"
                      type="number"
                      :min="form.isMetric ? '26.7' : '80'"
                      :max="form.isMetric ? '40.6' : '105'"
                      step="0.1"
                      :class="modalTheme"
                      :state="temperatureValidation"
                      :placeholder="form.isMetric ? '26.7 - 40.6' : '80.0 - 105.0'"
                      @focus="emit('field-focused', 'temperature')"
                    />
                    <b-input-group-append>
                      <b-input-group-text :class="modalTheme">{{ form.isMetric ? "°C" : "°F" }}</b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback :state="temperatureValidation"> Temperature must be between {{ form.isMetric ? "26.7°C and 40.6°C" : "80°F and 105°F" }} </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group label="temp method:" label-for="temperatureMethod" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-form-select id="temperatureMethod" v-model="form.temperatureMethod" size="sm" :class="modalTheme" :options="temperatureMethodOptions" />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="pulse:" label-for="pulse" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-input-group size="sm" :state="pulseValidation">
                    <b-form-input
                      id="pulse"
                      v-model="form.pulseRate"
                      type="number"
                      min="40"
                      max="200"
                      step="1"
                      :class="modalTheme"
                      :state="pulseValidation"
                      placeholder="40 - 200"
                      @focus="emit('field-focused', 'pulseRate')"
                    />
                    <b-input-group-append>
                      <b-input-group-text :class="modalTheme">bpm</b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback :state="pulseValidation"> Pulse must be between 40 and 200 bpm </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group label="pulse pattern:" label-for="pulsePattern" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-form-select id="pulsePattern" v-model="form.pulsePattern" size="sm" :class="modalTheme" :options="pulsePatternOptions" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group label="respiration:" label-for="respiration" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-input-group size="sm" :state="respirationValidation">
                    <b-form-input
                      id="respiration"
                      v-model="form.respirationRate"
                      type="number"
                      min="0"
                      max="50"
                      step="1"
                      :class="modalTheme"
                      :state="respirationValidation"
                      placeholder="0 - 50"
                      @focus="emit('field-focused', 'respirationRate')"
                    />
                    <b-input-group-append>
                      <b-input-group-text :class="modalTheme">/min</b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback :state="respirationValidation"> Respiration must be between 0 and 50 breaths per minute </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group label="resp pattern:" label-for="respirationPattern" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-form-select id="respirationPattern" v-model="form.respirationPattern" size="sm" :class="modalTheme" :options="respirationPatternOptions" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group label="O2 Saturation:" label-for="o2Saturation" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-input-group size="sm" :state="o2SaturationValidation">
                    <b-form-input
                      id="o2Saturation"
                      v-model="form.o2Saturation"
                      type="number"
                      min="50"
                      max="100"
                      step="0.1"
                      :class="modalTheme"
                      :state="o2SaturationValidation"
                      placeholder="50.0 - 100.0"
                      @focus="emit('field-focused', 'o2Saturation')"
                    />
                    <b-input-group-append>
                      <b-input-group-text :class="modalTheme">%</b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback :state="o2SaturationValidation"> O2 Saturation must be between 50% and 100% </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group label="Pain Level:" label-for="painLevel" label-cols="4" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                  <b-input-group size="sm">
                    <b-form-select id="painLevel" v-model="form.painLevel" size="sm" :class="modalTheme" :options="painLevelOptions" />
                    <b-input-group-append>
                      <b-input-group-text :class="modalTheme">(Scale: 0-10)</b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <!-- <div class="form-section full-width" :class="userStore.borderClass">
            <h3 style="text-align: left">FORM</h3>

            <b-form-group class="mb-2">
              <pre>{{ form }}</pre>
            </b-form-group>
          </div> -->
        </b-col>

        <b-col cols="12" md="6">
          <div class="form-section full-width" :class="userStore.borderClass">
            <h3 style="text-align: left">Comments</h3>

            <b-form-group class="mb-2">
              <b-form-textarea id="notes" :class="modalTheme" v-model="form.comments" size="sm" placeholder="Enter Comments (max 10000 chars)" rows="6" max-rows="15" maxlength="10000" />
            </b-form-group>
          </div>
        </b-col>
        <!-- <b-col>
          <pre style="color: cyan"><h4>{{ form }}</h4></pre>
        </b-col> -->
      </b-row>
      <!--
      props.isNewRecord
      <h2>{{ props.isNewRecord }}</h2> -->
      <!-- <hr /> -->
      <div class="form-actions">
        <b-button type="reset" variant="secondary">Reset</b-button>
        <b-button type="submit" variant="primary">Save Vitals</b-button>
      </div>
    </b-form>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import moment from "moment";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STORE
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();

import { postPatientVitals, putPatientVitals } from "@/api/patientApi";

const modalTheme = computed(() => userStore.bModalTheme);
const formattedCollectionDateTime = computed(() => (props.record?.collectionDateTime ? moment(props.record.collectionDateTime).utc().format("lll") : ""));

// Emits
const emit = defineEmits(["save-patient", "reset-form", "vitals-saved", "field-focused"]);

// & PROPS
const props = defineProps({
  record: {
    type: Object,
    default: true,
  },
  isNewRecord: {
    type: Boolean,
    default: true,
  },
});

// Form state
const form = ref(createForm());
const AreIdsShown = ref(true);
const isMetric = ref(false); // Track current unit system (false = Imperial, true = Metric)

const selectedRow = ref({ ...(props.records || {}) });

watch(
  () => props.record,
  (newVal) => {
    selectedRow.value = { ...(newVal || {}) };
  },
  { deep: true }
);

watch(
  () => props.isNewRecord,
  (newVal) => {
    if (newVal === false) {
      loadFromProps();
    }
  }
);

const bpPositionOptions = [
  { value: 0, text: "Select" },
  { value: 1, text: "Sitting" },
  { value: 2, text: "Standing" },
  { value: 3, text: "Supine" },
];

const bpCuffLocationOptions = [
  { value: 0, text: "Select" },
  { value: 1, text: "Left upper arm" },
  { value: 2, text: "Right upper arm" },
  { value: 3, text: "Left wrist" },
  { value: 4, text: "Right wrist" },
  { value: 5, text: "Left thigh" },
  { value: 6, text: "Right thigh" },
];

const bpCuffSizeOptions = [
  { value: 0, text: "Select" },
  { value: 1, text: "Child" },
  { value: 2, text: "Small adult" },
  { value: 3, text: "Adult" },
  { value: 4, text: "Large adult" },
  { value: 5, text: "Thigh" },
];

const temperatureMethodOptions = [
  { value: 0, text: "Select" },
  { value: 1, text: "Oral" },
  { value: 2, text: "Tympanic" },
  { value: 3, text: "Temporal" },
  { value: 4, text: "Axillary" },
  { value: 5, text: "Rectal" },
  { value: 6, text: "Other" },
];

const pulsePatternOptions = [
  { value: 0, text: "Select" },
  { value: 1, text: "Regular" },
  { value: 2, text: "Irregular" },
  { value: 3, text: "Weak" },
  { value: 4, text: "Bounding" },
];

const respirationPatternOptions = [
  { value: 0, text: "Select" },
  { value: 1, text: "Regular" },
  { value: 2, text: "Shallow" },
  { value: 3, text: "Deep" },
  { value: 4, text: "Labored" },
  { value: 5, text: "Cheyne-Stokes" },
  { value: 6, text: "Other" },
];

const painLevelOptions = Array.from({ length: 11 }, (_, value) => ({
  value,
  text: String(value),
}));

// Temperature validation computed property (dynamic based on unit system)
const temperatureValidation = computed(() => {
  if (!form.value.temperature) return null; // No validation if empty
  const temp = parseFloat(form.value.temperature);
  if (isMetric.value) {
    // Celsius range: 26.7 to 40.6°C
    return temp >= 26.7 && temp <= 40.6 ? true : false;
  } else {
    // Fahrenheit range: 80 to 105°F
    return temp >= 80 && temp <= 105 ? true : false;
  }
});

// Pulse validation computed property
const pulseValidation = computed(() => {
  if (!form.value.pulse) return null;
  const pulse = parseInt(form.value.pulse);
  return pulse >= 40 && pulse <= 200 ? true : false;
});

// Respiration validation computed property
const respirationValidation = computed(() => {
  if (!form.value.respiration) return null;
  const resp = parseInt(form.value.respiration);
  return resp >= 0 && resp <= 50 ? true : false;
});

// O2 Saturation validation computed property
const o2SaturationValidation = computed(() => {
  if (!form.value.o2Saturation) return null;
  const o2 = parseFloat(form.value.o2Saturation);
  return o2 >= 50 && o2 <= 100 ? true : false;
});

// Height validation computed property (dynamic based on unit system)
const heightValidation = computed(() => {
  if (!form.value.height) return null;
  const height = parseFloat(form.value.height);
  if (isMetric.value) {
    // Centimeters range: 137 to 183 cm
    return height >= 137 && height <= 183 ? true : false;
  } else {
    // Inches range: 54 to 72 inches
    return height >= 54 && height <= 80 ? true : false;
  }
});

// Weight validation computed property (dynamic based on unit system)
const weightValidation = computed(() => {
  if (!form.value.weight) return null;
  const weight = parseFloat(form.value.weight);
  if (isMetric.value) {
    // Kilograms range: 32 to 136 kg
    return weight >= 32 && weight <= 136 ? true : false;
  } else {
    // Pounds range: 70 to 300 lbs
    return weight >= 70 && weight <= 300 ? true : false;
  }
});

// Form validation
const isFormValid = () => {
  // Validate temperature range
  if (form.value.temperature && temperatureValidation.value === false) {
    const tempRange = isMetric.value ? "26.7°C and 40.6°C" : "80°F and 105°F";
    alert(`Temperature must be between ${tempRange}`);
    return false;
  }

  // Validate pulse range
  if (form.value.pulse && pulseValidation.value === false) {
    alert("Pulse must be between 40 and 200 bpm");
    return false;
  }

  // Validate respiration range
  if (form.value.respiration && respirationValidation.value === false) {
    alert("Respiration must be between 0 and 50 breaths per minute");
    return false;
  }

  // Validate O2 saturation range
  if (form.value.o2Saturation && o2SaturationValidation.value === false) {
    alert("O2 Saturation must be between 50% and 100%");
    return false;
  }

  // Validate height range
  if (form.value.height && heightValidation.value === false) {
    const heightRange = isMetric.value ? "137 and 183 cm" : "54 and 80 inches";
    alert(`Height must be between ${heightRange}`);
    return false;
  }

  // Validate weight range
  if (form.value.weight && weightValidation.value === false) {
    const weightRange = isMetric.value ? "32 and 136 kg" : "70.0 and 300.0 lbs";
    alert(`Weight must be between ${weightRange}`);
    return false;
  }

  return true;
};

// Create form factory function
function createForm() {
  return {
    weight: 0,
    height: 0,
    temperature: 0,
    temperatureMethod: 0,
    pulseRate: 0,
    pulsePattern: 0,
    bpSystolic: 0,
    bpDistolic: 0,
    bpPosition: 0,
    bpCuffLocation: 0,
    bpCuffSize: 0,
    bpPalpated: false,
    respirationRate: 0,
    respirationPattern: 0,
    o2Saturation: 0,
    peakFlow: 0,
    painLevel: 0,
    comments: "",
    isMetric: false,
  };
}

// Form handlers
async function onSubmit() {
  if (!isFormValid()) {
    return;
  }
  console.log(form.value);

  const payload = {
    ...form.value,
    weight: parseFloat(form.value.weight) || 0,
    height: parseFloat(form.value.height) || 0,
    temperature: parseFloat(form.value.temperature) || 0,
    temperatureMethod: parseInt(form.value.temperatureMethod) || 0,
    pulseRate: parseInt(form.value.pulseRate) || 0,
    pulsePattern: parseInt(form.value.pulsePattern) || 0,
    bpSystolic: parseInt(form.value.bpSystolic) || 0,
    bpDistolic: parseInt(form.value.bpDistolic) || 0,
    bpPosition: parseInt(form.value.bpPosition) || 0,
    bpCuffLocation: parseInt(form.value.bpCuffLocation) || 0,
    bpCuffSize: parseInt(form.value.bpCuffSize) || 0,
    respirationRate: parseInt(form.value.respirationRate) || 0,
    respirationPattern: parseInt(form.value.respirationPattern) || 0,
    o2Saturation: parseFloat(form.value.o2Saturation) || 0,
    peakFlow: parseFloat(form.value.peakFlow) || 0,
    painLevel: parseInt(form.value.painLevel) || 0,
  };

  // TODO  EMT - patient refresh()       >>>>
  // emit("save-patient", payload);

  if (props.isNewRecord) {
    console.log("Saving postPatientVitals:", payload);

    payload.personId = patientStore.currentPatient.personID;
    payload.id = 0;

    console.log("modified personId and id >  check :", payload);

    const responsPOST = await postPatientVitals(payload);
    console.log("responsPOST");
    console.log(responsPOST);

    if (responsPOST.ok) {
      console.log("responsPOST");
      console.log(responsPOST);
      emit("vitals-saved");
    } else {
      console.log("responsPOST");
      console.log(responsPOST.message);
    }
  } else {
    console.log("Saving putPatientVitals:", payload);
    const responsPUT = await putPatientVitals(payload);
    console.log("responsPUT");
    console.log(responsPUT);

    if (responsPUT.ok) {
      console.log("responsPUT");
      console.log(responsPUT);
      emit("vitals-saved");
    } else {
      console.log("responsPUT");
      console.log(responsPUT.message);
    }
  }

  onReset();
}

function onReset() {
  form.value = createForm();
  selectedRow.value = {};
  emit("reset-form");
}

// Load initial data (example with the provided values)
function loadSampleData() {
  form.value = {
    temperature: 101,
    temperatureMethod: 1,
    pulseRate: 65,
    pulsePattern: 1,
    bp: 110 / 74,
    respirationRate: 14,
    respirationPattern: 1,
    o2Saturation: 98,
    height: 62,
    weight: 200,
    bpSystolic: 110,
    bpDistolic: 62,
    bpPosition: 1,
    bpCuffLocation: 1,
    bpCuffSize: 3,
    comments: "POST Testing . . .",
    painLevel: 2,
  };
}
function loadSampleDataOoRange() {
  form.value = {
    temperature: 106.5, // Out of range (80-105)
    temperatureMethod: 3,
    pulseRate: 250, // Out of range (40-200)
    pulsePattern: 2,
    bp: 260 / 150,
    respirationRate: 55, // Out of range (0-50)
    respirationPattern: 2,
    o2Saturation: 45, // Out of range (50-100)
    height: 48, // Out of range (54-72)
    weight: 350, // Out of range (70-300)
    bpSystolic: 260,
    bpDistolic: 150,
    bpPosition: 3,
    bpCuffLocation: 1,
    bpCuffSize: 2,
    bpPalpated: false,
    peakFlow: 0,
    painLevel: 10,
    comments: "Out of range test",
    isMetric: false,
  };
}

//  ! REMOVED   METRIC   Unit conversion toggle function
// function toggleUnits() {
//   if (isMetric.value) {
//     // Convert from Metric to Imperial
//     // Convert temperature from Celsius to Fahrenheit
//     if (form.value.temperature) {
//       form.value.temperature = parseFloat(((form.value.temperature * 9) / 5 + 32).toFixed(1));
//     }

//     // Convert height from centimeters to inches
//     if (form.value.height) {
//       form.value.height = parseFloat((form.value.height / 2.54).toFixed(1));
//     }

//     // Convert weight from kilograms to pounds
//     if (form.value.weight) {
//       form.value.weight = parseFloat((form.value.weight * 2.20462).toFixed(1));
//     }

//     isMetric.value = false;
//     console.log("Converted to imperial units");

//     form.value.isMetric = isMetric.value;
//   } else {
//     // Convert from Imperial to Metric
//     // Convert temperature from Fahrenheit to Celsius
//     if (form.value.temperature) {
//       form.value.temperature = parseFloat((((form.value.temperature - 32) * 5) / 9).toFixed(1));
//     }

//     // Convert height from inches to centimeters
//     if (form.value.height) {
//       form.value.height = parseFloat((form.value.height * 2.54).toFixed(1));
//     }

//     // Convert weight from pounds to kilograms
//     if (form.value.weight) {
//       form.value.weight = parseFloat((form.value.weight / 2.20462).toFixed(1));
//     }

//     isMetric.value = true;
//     console.log("Converted to metric units");
//     form.value.isMetric = isMetric.value;
//   }
// }

function loadFromProps() {
  if (props.record && typeof props.record === "object") {
    form.value = {
      ...createForm(),
      ...props.record,

      // chartReviewDate: props.testPatient.chartReviewDate ? moment(props.testPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      // startDate: props.testPatient.startDate ? moment(props.testPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      // endDate: props.testPatient.endDate ? moment(props.testPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      // nextAppointment: props.testPatient.nextAppointment ? moment(props.testPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
  }
}

// New method to bind from store object to form
function loadFromPatientStore() {
  const currentPatient = patientStore.currentPatient;
  if (currentPatient && typeof currentPatient === "object") {
    form.value = {
      ...createForm(),
      ...currentPatient,
      // Handle date conversions
      // dateOfBirth: currentPatient.dateOfBirth ? moment(currentPatient.dateOfBirth).format("YYYY-MM-DD") : "",
      // serviceDate: currentPatient.serviceDate ? moment(currentPatient.serviceDate).format("YYYY-MM-DD") : "",
      // chartReviewDate: currentPatient.chartReviewDate ? moment(currentPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      // startDate: currentPatient.startDate ? moment(currentPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      // endDate: currentPatient.endDate ? moment(currentPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      // nextAppointment: currentPatient.nextAppointment ? moment(currentPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
    console.log("Loaded patient from store:", currentPatient);
  } else {
    console.warn("No current patient found in store");
    alert("No current patient available in store");
  }
}

// // Custom directive for unit-based background colors
// const vUnitBackground = {
//   mounted(el, binding) {
//     updateBackground(el, binding.value);
//   },
//   updated(el, binding) {
//     updateBackground(el, binding.value);
//   },
// };

// function updateBackground(el, isMetric) {
//   if (isMetric) {
//     // Blue shade for metric
//     // el.style.backgroundColor = "#e3f2fd";
//     el.style.border = "2px solid #2196f3";
//   } else {
//     // Red shade for imperial
//     // el.style.backgroundColor = "#ffebee";
//     el.style.border = "2px solid #f44336";
//   }
// }

onMounted(() => {
  // console.clear();
  console.log("onMounted() : Patient    NEW VITALS       Form >>>>");
  console.log("props :                          isVitalsNewRecord ");
  console.log(props.isVitalsNewRecord);

  console.log("props :                          record ");
  console.log(props.record);
  // loadSampleData();
  // loadFromProps();
  // loadFromPatientStore();
});
</script>

<style scoped>
.gutter-6 {
  --bs-gutter-x: 6px;
  --bs-gutter-y: 6px;
}
.gutter-6 > * {
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.patient-form-container {
  background: transparent;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0px;
  overflow: hidden;
  overflow-y: auto;
  margin-left: 12px;
  padding-left: 12px;
  padding-right: 12px;
}

.form-section {
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.form-section h3 {
  margin-bottom: 15px;
  font-size: 1.2em;
  border-bottom: 2px solid #007bff;
  padding-bottom: 5px;
  text-align: center;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 0;
  border-top: 1px solid #dee2e6;
  margin-top: 20px;
}

hr {
  border: none;
  height: 1px;
  background-color: #0d85fd;
  margin: 20px 0;
}

/* Bootstrap Vue form group label alignment */
.b-form-group .col-form-label {
  font-size: 15px !important;
  font-weight: 600;
  text-align: right !important;
  justify-content: flex-end !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  white-space: nowrap;
}

/* Remove Bootstrap Vue form group internal spacing */
.b-form-group {
  margin-bottom: 0.5rem !important;
}

.b-form-group .row {
  margin: 0 !important;
}

.b-form-group .row > [class*="col"] {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/* 10px gap between label and input columns */
.form-section .b-form-group .row > [class*="col"]:first-child {
  padding-right: 10px !important;
  padding-left: 0 !important;
}

.form-section .b-form-group .row > [class*="col"]:not(:first-child) {
  padding-left: 0 !important;
  padding-right: 5px !important;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .form-group {
    min-width: unset;
  }
}

/* Top form actions styles (currently commented out)
.form-actions-top {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 0;
  margin-bottom: 20px;
  border-bottom: 1px solid #dee2e6;
}

.current-patient-info {
  color: #28a745;
  font-weight: 600;
  font-size: 14px;
}

.no-patient-info {
  color: #dc3545;
  font-style: italic;
  font-size: 14px;
}
*/

.radio-group {
  flex-direction: column;
  align-items: flex-start;
}

.radio-group > label {
  min-width: auto;
  margin-bottom: 10px;
  font-weight: 600;
}

.radio-options {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 10px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: normal;
  cursor: pointer;
  min-width: auto;
  margin-bottom: 0;
  text-align: left;
}

.radio-label input[type="radio"] {
  margin: 0;
  width: 16px;
  height: 16px;
}

/* Add/override for city/state row alignment */
.form-section .b-form-group .row.no-gutters {
  margin-left: 0 !important;
  margin-right: 0 !important;
  gap: 0 !important;
}

.form-section .b-form-group .row.no-gutters > [class*="col"] {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Reduce gap between city and state columns */
.form-section .b-form-group .row.no-gutters > .pr-1 {
  padding-right: 4px !important;
}

.form-section .b-form-group .row.no-gutters > .pl-1 {
  padding-left: 4px !important;
}
</style>
